import * as _ from 'lodash';
import * as utility from '../misc/utility';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
*/

export class PendingCertification {
    constructor(src) {
        this.CertifierId = src.CertifierId;
        this.OrganizationId = src.OrganizationId;
        this.IsPrimary = src.IsPrimary;
        this.Count = src.Count;
        this.FirstPendingTimestamp = utility.parseDate(src.FirstPendingTimestamp);
    }

    /**
     * 
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.Certifier = ctx.getPerson(this.CertifierId);
        this.Organization = ctx.getOrganization(this.OrganizationId);
    }

    static fromResponse(rsp) {
        let result = rsp.getResult();
        let context = rsp.context;
        return _.map(result, x => {
            let pc = new PendingCertification(x);
            pc.resolve(context);
            return pc;
        });
    }
}